import { defineDocs } from "fumadocs-mdx/macro";
import { marketingSchema } from "./marketing-schema";

// One frontmatter contract for all four marketing collections.

export const feature = defineDocs({
  dir: "src/content-site/content/feature",
  docs: { schema: marketingSchema, async: true, postprocess: { includeProcessedMarkdown: true } },
});
export const audience = defineDocs({
  dir: "src/content-site/content/audience",
  docs: { schema: marketingSchema, async: true, postprocess: { includeProcessedMarkdown: true } },
});

export const docs = defineDocs({
  dir: "src/content-site/content/docs",
  docs: { async: true, postprocess: { includeProcessedMarkdown: true } },
});

export const marketing = defineDocs({
  dir: "src/content-site/content/compare",
  docs: { schema: marketingSchema, async: true, postprocess: { includeProcessedMarkdown: true } },
});

// Only published articles live here. Drafts stay outside all public collections.
export const blog = defineDocs({
  dir: "src/content-site/content/blog",
  docs: { schema: marketingSchema, async: true, postprocess: { includeProcessedMarkdown: true } },
});
